export function Vignette() {
  return <div className="vignette" aria-hidden />
}
